export default __webpack_public_path__ + "static/media/clinic8.b6ebda61.jpg";